import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/message-kinds/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const messageKinds = {
  getAll: apiPathFunc(pathBase),
} as const;
